import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { TelephoneType } from './@globalTypes';

export const parsePhoneNumber = (rawPhone: string) => {
  const parsed = parsePhoneNumberFromString('+' + rawPhone);
  const dataToSave: TelephoneType = {
    country_code: '',
    phone_code: '',
    phone_number: '',
  };
  if (parsed) {
    (dataToSave.country_code = parsed.country || ''), // ISO-код страны (BY, RU, US и т.д.)
      (dataToSave.phone_code = '+' + parsed.countryCallingCode || ''), // Код страны (375, 7, 1 и т.д.)
      (dataToSave.phone_number = parsed.nationalNumber || ''); // Оставшаяся часть номера
  }
  return dataToSave;
};
